import React, { type RefObject, useContext } from 'react';

import { VerifiedTeamIcon } from '@atlaskit/people-teams-ui-public/verified-team-icon';
import { Inline, Text } from '@atlaskit/primitives/compiled';

import { TeamInlinePreviewContext } from '../../store/context';

/**
 * Internal component that renders the team type text and optional verified icon.
 * Supports single-line mode and accepts an optional ref for truncation detection.
 */
function TeamType({
	teamType,
	elementRef,
	showVerified = false,
}: {
	teamType?: string;
	elementRef?: RefObject<HTMLElement>;
	showVerified?: boolean;
}): React.JSX.Element | null {
	const { singleLine, getTestId } = useContext(TeamInlinePreviewContext);
	const maxLines = singleLine ? 1 : undefined;

	if (!teamType) {
		return null;
	}

	return (
		<Inline alignBlock="center" space="space.025">
			<Text
				size="small"
				maxLines={maxLines}
				ref={elementRef}
				color="color.text.subtle"
				align="start"
				testId={getTestId('team-type')}
			>
				{teamType}
			</Text>
			{showVerified ? <VerifiedTeamIcon /> : null}
		</Inline>
	);
}

export { TeamType };
